import type { Locale } from "@renza/shared";

export const isDa = (locale: Locale) => locale === "da";
export const quotePath = (locale: Locale) =>
  locale === "da" ? "/faa-tilbud" : "/en/request-quote";
export const contactPath = (locale: Locale) =>
  locale === "da" ? "/kontakt" : "/en/contact";
export const homePath = (locale: Locale) => (locale === "da" ? "/" : "/en");
